import request from 'api/requestUtils'
// import { templates } from '@luxuryescapes/lib-uri-templates'

export function getSupportChats() {
  const uri = '/api/support/v1/chats'
  // const uri = templates.support.chats.expand({})

  return request.get<App.ApiResponse<Record<any, any>[]>>(uri, { credentials: 'include' })
    .then(data => data.result)
}

export function getSupportChatById(chatId) {
  const uri = `/api/support/v1/chats/${chatId}?includeMessages=true&includeAgent=true`

  return request.get<App.ApiResponse<Record<any, any>[]>>(uri, { credentials: 'include' })
    .then(data => data.result)
}

export function updateChat(chat) {
  const uri = `/api/support/v1/chats/${chat.id}`

  return request.put<App.ApiResponse<Record<any, any>>, App.ApiResponse<Record<any, any>>>(uri, chat, { credentials: 'include' })
    .then(data => data.result)
}

export function postFeedback(feedback) {
  const uri = '/api/support/v1/feedbacks'

  return request.post<App.ApiResponse<Record<any, any>>, App.ApiResponse<Record<any, any>>>(uri, feedback, { credentials: 'include' })
    .then(data => data.result)
}

export function createGenesysConversation(payload) {
  const uri = '/api/support/v1/genesys/conversations'

  return request.post<App.ApiResponse<Record<any, any>>, App.ApiResponse<Record<any, any>>>(uri, payload, { credentials: 'include' })
    .then(data => data.result)
}
